<template>
    <b-row class="mt-3">
        <b-col class="d-flex py-0 pe-0">
            <div class="mt-2">{{ total }} Results</div>
            <div class="ms-auto me-3">
                <p-select
                    v-if="total > minPerPage"
                    :model-value="perPage"
                    :options="perPageOptions"
                    class="per-page-select"
                    @update:model-value="$emit('per-page', Number($event))" />
            </div>
            <b-pagination
                v-if="total > perPage"
                :model-value="page"
                :total-rows="total"
                :per-page="perPage"
                @update:model-value="$emit('page', $event)" />
        </b-col>
    </b-row>
</template>

<script>
// The paging row p-search-table shows under its tables - result count, page-size selector,
// pager - for tables whose rows the server pages (report results, report activity).
const PER_PAGE_OPTIONS = [
    { value: 10, text: 'Show 10' },
    { value: 25, text: 'Show 25' },
    { value: 50, text: 'Show 50' },
    { value: 100, text: 'Show 100' },
    { value: 500, text: 'Show 500' },
];

export default {
    name: 'ServerPager',
    props: {
        total: { type: Number, default: 0 },
        page: { type: Number, default: 1 },
        perPage: { type: Number, default: 25 },
    },
    emits: ['page', 'per-page'],
    data() {
        return { perPageOptions: PER_PAGE_OPTIONS };
    },
    computed: {
        // As on p-search-table: no size to choose until there is more than the smallest page.
        minPerPage() {
            return Math.min(...this.perPageOptions.map(x => x.value));
        },
    },
};
</script>
